<template>
  <div>
    <div class="search-bar-margin-bottom-cla">
      <el-form :inline="true" :model="params">
        <el-form-item>
          <el-date-picker
            class="pickData_cla"
            v-model="value2"
            type="datetimerange"
            :default-time="['00:00:00', '23:59:59']"
            format="yyyy-MM-dd HH:mm:ss"
            @clear="getStatisticAppAggs"
            align="right"
            unlink-panels
            range-separator="-"
            :start-placeholder="$t('common.startTime')"
            :end-placeholder="$t('common.endTime')"
            :picker-options="pickerOptions"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-input
            clearable
            @clear="getStatisticAppAggs"
            :placeholder="this.$t('common.inputKeyWord')"
            v-model.trim="params.key"
            @keyup.enter.native="getStatisticAppAggs"
          >
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            @click="getStatisticAppAggs"
            type="primary"
            icon="el-icon-search"
            >{{ $t('common.search') }}</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <el-table :data="tableData">
      <el-table-column
        prop="fieldKey"
        :label="this.$t('statistics.appKey')"
      ></el-table-column>
      <el-table-column
        prop="fieldName"
        :label="this.$t('statistics.appName')"
      ></el-table-column>
      <el-table-column
        prop="count"
        :label="this.$t('statistics.callCount')"
      ></el-table-column>
      <el-table-column :label="this.$t('statistics.callDetail')">
        <template slot-scope="scope">
          <el-button
            class="btn-text-cla"
            @click.stop="details(scope.row)"
            type="text"
            >{{ $t('common.details') }}</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <el-drawer :title="currentRow.fieldName" :visible.sync="drawer">
      <div class="api-detail-drawer-cla">
        <div class="api-detail-header">
          <img
            class="statisticsChart-icon-cla"
            src="../../../assets/new/statistics/statisticsChart.svg"
          />

          <span>
            {{ $t('statistics.callTimes', { count: currentRow.count }) }}</span
          >
        </div>
        <div class="list-box-cla">
          <el-table :border="true" :data="currentRow.innerList">
            <el-table-column
              prop="fieldName"
              :label="this.$t('statistics.name')"
            ></el-table-column>
            <el-table-column
              prop="count"
              :label="this.$t('statistics.callCount')"
            ></el-table-column>
          </el-table>
        </div>
      </div>
    </el-drawer>
  </div>
</template>
<script>
// 查询条件 , apiName:
import {
  getStartTime,
  getEndTime,
  getCurrentDateStartAndEndTime
} from '@/utils/utils.js'
import { getStatisticAppAggs } from '@/services/statisticsApi.js'
import { defaultShortCuts } from '@/utils/pickerOptions.js'
export default {
  data() {
    return {
      pickerOptions: defaultShortCuts(this),
      value2: getCurrentDateStartAndEndTime(),
      params: {
        key: '',
        appCode: 'DBS'
      },
      tableData: [],
      drawer: false,
      loadingInstance: null,
      currentRow: {}
    }
  },
  mounted() {
    this.getStatisticAppAggs()
  },
  methods: {
    details(row) {
      this.currentRow = row
      this.drawer = true
    },
    getStatisticAppAggs() {
      let params = Object.assign({}, this.params)
      let valueLength = this.value2 && this.value2.length === 2
      if (valueLength) {
        params.startTime = getStartTime(this.value2[0])
        params.endTime = getEndTime(this.value2[1])
      }
      if (!params.key) {
        delete params.key
      }
      this.loadingInstance = this.$loading({
        lock: true,
        fullscreen: true,
        text: '',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })

      getStatisticAppAggs(params)
        .then(data => {
          if (data.code === '00000000') {
            this.tableData = data.payload.data
          } else {
            this.$message.error(data.message)
          }
        })
        .catch(e => {
          this.tableData = []
          this.$message.error(e)
        })
        .finally(() => {
          this.loadingInstance.close()
        })
    }
  }
}
</script>

<style scoped lang="less">
@import '~@/styles/var.less';
.api-detail-drawer-cla {
  padding: 12px 24px;
  .api-detail-header {
    height: 60px;
    line-height: 40px;
    display: flex;
    align-items: center;
    font-weight: 500;
    font-size: 20px;
    i {
      height: 30px;
      width: 30px;
      line-height: 30px;
      color: @themeColor;
      display: inline-block;
      text-align: center;
      font-size: 30px;
      margin-right: 10px;
    }
  }
  .list-box-cla {
    .apiDetails-item-cla {
      display: flex;
      align-items: center;
      height: 40px;
      line-height: 40px;
      &:hover {
        cursor: pointer;
        background-color: rgba(0, 0, 0, 0.2);
      }
      .line-cla {
        margin-right: 10px;
        display: inline-block;
        width: 40px;
        border-bottom: 1px solid gray;
        height: 1px;
      }
      .appName-cla {
        display: inline-block;
        min-width: 40px;
        margin-right: 10px;
      }
      .appCount-cla {
        display: inline-block;
      }
    }
  }
}

/deep/.el-drawer__body {
  margin-bottom: 0px !important;
}
/deep/.el-drawer__header {
  margin-bottom: 0px !important;
  padding: 10px;
}

/deep/ .el-table--border td,
.el-table--border th {
  border-right: 0.183333rem solid #ebeef5;
}

/deep/ .el-table thead tr th {
  background: #f9fafb;
}

.statisticsChart-icon-cla {
  width: 20px;
  height: 20px;
  margin-right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/modules/statistics/callDetails/appDetails.vue